// ModelPicker.tsx — the composer's model combobox. With a session open it
// switches that conversation's model (transcript kept); with none it picks
// the model the next New session gets. Hidden while the fleet list is
// empty. State and rules live in useModelPicker.ts / modelPicker.ts.
import React from 'react';
import { Spinner } from 'react-bootstrap';
import { ui } from 'common';
import type { ModelPicker as ModelPickerState } from './useModelPicker';

export interface ModelPickerProps {
  picker: ModelPickerState;
  /** A session is open, so the picker governs it rather than the next New. */
  hasSession: boolean;
}

const ModelPicker: React.FC<ModelPickerProps> = ({ picker, hasSession }) => {
  if (picker.models.length === 0) return null;
  return (
    <div className="d-flex align-items-center gap-2">
      <ui.Combobox
        value={picker.modelDraft}
        onChange={picker.onDraftChange}
        onFocus={picker.onFocus}
        onBlur={picker.onBlur}
        options={picker.models}
        placeholder={picker.activeModel || 'model'}
        disabled={picker.modelSwitching}
        title={hasSession
          ? 'Model for this conversation — switching keeps the transcript'
          : 'Model for the next session you create'}
        aria-label={hasSession ? 'Session model' : 'Model for new sessions'}
        minWidth={picker.widthCh}
        style={{
          padding: '0.25rem 0.5rem',
          fontSize: '0.875rem',
        }}
      />
      {picker.modelSwitching && <Spinner animation="border" size="sm" />}
    </div>
  );
};

export default ModelPicker;
